import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

let resError = ''
export const ACCOUNT_FORGOT_PASSWORD = async ({ params }) => {
  try {
    return await clientPublic
      .post(`account/forgot`, params, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        const Error = response.data
        return Error
      })
  } catch (error) {

    console.error('error', error)
    return resError
  }
}



export const CHECK_CODE_FORGOT_PASSWORD = async ({ params }) => {
  try {
    return await clientPublic
      .post(`account/forgot/check`, params, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        resError = response
        const Error = get(response, 'data', '')
        return Error
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const RESET_FORGOT_PASSWORD = async ({ params }) => {
  try {
    return await clientPublic
      .post(`account/forgot/reset`, params, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        resError = response
        const Error = get(response, 'data', '')
        return Error
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}